module.exports = __webpack_public_path__ + "img/cliScrub.119b71be.jpg";